export const TRACKING_EVENT_TYPE = {
	PLACEHOLDER_STAFFED: 'PLACEHOLDER_STAFFED',
	GLOBAL_SEARCH_RESULT_SELECTED: 'GLOBAL_SEARCH_RESULT_SELECTED',
	TIME_REGISTRATION_MODAL_SEARCH_RESULT_SELECTED: 'TIME_REGISTRATION_MODAL_SEARCH_RESULT_SELECTED',
	TASK_MODAL_VIEWED: 'TASK_MODAL_VIEWED',
	TIME_REGISTRATION_TARGET_SUGGESTION_FEEDBACK: 'TIME_REGISTRATION_TARGET_SUGGESTION_FEEDBACK',
	TIME_REGISTRATION_SUGGESTIONS_SHOWN: 'TIME_REGISTRATION_SUGGESTIONS_SHOWN',
} as const;
export type TrackingEventType = (typeof TRACKING_EVENT_TYPE)[keyof typeof TRACKING_EVENT_TYPE];
